import { defineMessages } from 'react-intl';

export default defineMessages({
  numPolice: {
    id: 'dashboard_auto.mes_contracts.num_police',
  },
  dateEffet: {
    id: 'auto_details.my_contracts.date_effet',
  },
  dateEcheance: {
    id: 'signup_auth_by_contract_success.due_date',
  },
  status: {
    id: 'auto_details.my_contracts.status',
  },
  immatriculation: {
    id: 'signup_auth_by_contract_success.matriculation',
  },
  produit: {
    id: 'auto_details.my_contracts.produit',
  },
  tarif: {
    id: 'auto_details.my_contracts.tarif',
  },
});
